import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderDraft,
  BackendMutationNameBlogPostBuilderDraftArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation NameBlogPostBuilderDraft($projectId: ID!, $draftId: ID!, $name: String!) {
    nameBlogPostBuilderDraft(projectId: $projectId, draftId: $draftId, name: $name) {
      id
    }
  }
`;

type Variables = BackendMutationNameBlogPostBuilderDraftArgs;
type Result = Pick<BackendBlogPostBuilderDraft, 'id'>;

export const nameBlogPostBuilderDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
